<template>
  <ModalProfile
    ref="modal"
    v-if="modalShowProfile"
    @closeModal="closeModalProfile"
  />
  <section class="pb-96 h-fit">
    <PageHeader title="Settings" class="max-w-96 mb-8" subtitle=""/>
    <div class="parent-grid">
      <div class="child-grid">
        <Card @click="showModalProfile" card_class="border-white/70 py-6 hover:bg-white/40 cursor-pointer hover:text-black">
          <div class="flex justify-center">
            <img src="/images/icons/profile.webp" alt="Profile" class="mb-2 md:w-12 md:h-12">
          </div>
          <h5 class="text-center font-semibold capitalize">Profile</h5>
        </Card>
      </div>
      <template v-for="(menu, index) in menus" :key="index">
        <div class="child-grid">
          <router-link :to="menu.path">
            <Card card_class="border-white/70 py-6 hover:bg-white/40 hover:text-black">
              <div class="flex justify-center">
                <img :src="menu.image_path" :alt="menu.name" class="mb-2 md:w-12 md:h-12">
              </div>
              <h5 class="text-center font-semibold capitalize">{{ menu.name }}</h5>
            </Card>
          </router-link>
        </div>
        
      </template>
    </div>
  </section>
</template>

<script>
// import ButtonRouter from "@/components/buttons/ButtonRouter.vue";
import PageHeader from "@/components/molecules/PageHeader.vue";
import Card from "@/components/organisms/Card.vue";
import ModalProfile from "@/components/modals/ModalProfile.vue";

export default {
  name: "Settings",
  components: {
    PageHeader,
    ModalProfile,
    Card,
    // ButtonRouter,
  },
  data() {
    return {
      menus: [
        { name: "Branch", path: "/setting/branch", image_path: "/images/icons/branch.webp"},
        { name: "Category - Product", path: "/setting/category", image_path: "/images/icons/category.webp"},
        { name: "Coupon", path: "/setting/coupon", image_path: "/images/icons/ticket.webp"},
        { name: "User Activities", path: "/setting/user-activities", image_path: "/images/icons/user_activity.webp"},
      ],

      modalShowProfile: false,
    };
  },
  methods: {
    showModalProfile() {
      this.modalShowProfile = true;
    },
    closeModalProfile() {
      this.modalShowProfile = false;
    },
  }
};
</script>

<style scoped>
  .parent-grid {
    display: grid;
    gap: 1rem;
    grid-template-columns: repeat(4, 1fr);
  }

  /* Tablet */
  @media (max-width: 1024px) {
    .parent-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  /* Mobile */
  @media (max-width: 640px) {
    .parent-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    img {
      width: 3rem;
      height: 3rem;
    }
  }
</style>